import { PreIPOEnquiresReducerStateType } from '@modules/pre-ipo-deals/pre-ipo-deals-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'dateOfEnquiry',
  clearPage: true,
  totalCount: 0,
  date: null,
  status: 'all',
  deals: '',
  updateSharePriceClicked: false,
  markAsCompletedClicked: false,
  droppedOffClicked: false,
  selectedUsers: [],
  closedClicked: false
} as PreIPOEnquiresReducerStateType;

export const preIPOEnquiresListStateReducerSlice = createSlice({
  name: 'preIPOEnquiresListStateReducer',
  initialState,
  reducers: {
    resetPreIPOEnquiresListStateReducerValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'dateOfEnquiry',
      totalCount: 0,
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: [],
      updateSharePriceClicked: false,
      markAsCompletedClicked: false,
      droppedOffClicked: false,
      closedClicked: false
    }),
    updatePreIPOEnquiresListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    resetPreIPOEnquiresFiltersStateReducerValues: state => ({
      ...state,
      search: '',
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: []
    })
  }
});

export const {
  resetPreIPOEnquiresListStateReducerValues,
  updatePreIPOEnquiresListStateReducerValues,
  resetPreIPOEnquiresFiltersStateReducerValues
} = preIPOEnquiresListStateReducerSlice.actions;

export default preIPOEnquiresListStateReducerSlice.reducer;
